export const ADD = "ADD";
export const REMOVE = "REMOVE";
export const CLEAR = "CLEAR";
export const SET_BREADCRUMB = "SET_BREADCRUMB";
